/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Launch_Stat_CategoriesInputs */

const en_directory_launch_stat_categories = /** @type {(inputs: Directory_Launch_Stat_CategoriesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} categories updated`)
};

const zh_directory_launch_stat_categories = /** @type {(inputs: Directory_Launch_Stat_CategoriesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个分类有更新`)
};

/**
* | output |
* | --- |
* | "{count} categories updated" |
*
* @param {Directory_Launch_Stat_CategoriesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_stat_categories = /** @type {((inputs: Directory_Launch_Stat_CategoriesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Stat_CategoriesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_stat_categories(inputs)
	return zh_directory_launch_stat_categories(inputs)
});
export { directory_launch_stat_categories as "directory.launch.stat_categories" }